module.exports = __webpack_public_path__ + "img/customer-feedback.494b01ac.png";